import { render, staticRenderFns } from "./ListItemAddonCategory.vue?vue&type=template&id=9bdcd944&"
import script from "./ListItemAddonCategory.vue?vue&type=script&lang=js&"
export * from "./ListItemAddonCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports